import React from 'react';
import { ExternalLink, Github, Star } from 'lucide-react';
import Footer from '../components/Footer';

const Projects = () => {
  const projects = [
    {
      name: 'Système de Gestion de Bibliothèque',
      description: 'Application web complète pour la gestion de bibliothèque. Gère le catalogage des livres, la gestion des utilisateurs, le système de prêt et la fonctionnalité de recherche avec une interface intuitive.',
      tags: ['PHP', 'MySQL', 'Application Web', 'CRUD'],
      year: '2024',
      link: 'https://github.com/twillsonepitech/library',
      github: 'https://github.com/twillsonepitech/library',
      status: 'Terminé',
      language: 'PHP'
    },
    {
      name: 'Jeu Gomoku avec IA',
      description: 'Jeu Gomoku graphique avec intelligence artificielle. Implémente l\'algorithme minimax avec élagage alpha-bêta pour un gameplay intelligent. Construit avec C++ et interface graphique.',
      tags: ['C++', 'IA', 'Développement de Jeux', 'Algorithme'],
      year: '2023',
      link: 'https://github.com/twillsonepitech/Gomoku',
      github: 'https://github.com/twillsonepitech/Gomoku',
      status: 'Terminé',
      language: 'C++'
    },
    {
      name: 'Antman - Compression Huffman',
      description: 'Outil de compression et décompression de fichiers utilisant l\'algorithme de Huffman. Compression de données sans perte efficace avec implémentation d\'encodage optimal.',
      tags: ['C', 'Algorithme', 'Compression', 'Structures de Données'],
      year: '2022',
      link: 'https://github.com/twillsonepitech/Antman',
      github: 'https://github.com/twillsonepitech/Antman',
      status: 'Terminé',
      language: 'C',
      license: 'MIT'
    },
    {
      name: 'Application Mariage (Flutter)',
      description: 'Application mobile construite avec Flutter/Dart pour la planification et la gestion de mariages. Comprend la planification d\'événements, la gestion des invités et le partage de photos.',
      tags: ['Dart', 'Flutter', 'Mobile', 'Multiplateforme'],
      year: '2023',
      link: 'https://github.com/twillsonepitech/wedding',
      github: 'https://github.com/twillsonepitech/wedding',
      status: 'Terminé',
      language: 'Dart'
    },
    {
      name: 'Jeu Matchstick (Rust)',
      description: 'Implémentation du jeu Matchstick en Rust. Comprend la logique du jeu, un adversaire IA et une interface en ligne de commande avec gestion robuste des erreurs.',
      tags: ['Rust', 'Logique de Jeu', 'CLI', 'Programmation Système'],
      year: '2023',
      link: 'https://github.com/twillsonepitech/Matchstick',
      github: 'https://github.com/twillsonepitech/Matchstick',
      status: 'Terminé',
      language: 'Rust'
    },
    {
      name: 'Serveur FTP (C)',
      description: 'Implémentation d\'un serveur FTP suivant le protocole RFC959. Supporte plusieurs clients, transferts de fichiers, navigation dans les répertoires et commandes FTP standard.',
      tags: ['C', 'FTP', 'RFC959', 'Réseau'],
      year: '2023',
      link: 'https://github.com/twillsonepitech/C-modul-FTP',
      github: 'https://github.com/twillsonepitech/C-modul-FTP',
      status: 'Terminé',
      language: 'C'
    },
    {
      name: 'Projet Java POO',
      description: 'Projet de programmation orientée objet démontrant des concepts Java avancés. Implémente des design patterns, l\'héritage, le polymorphisme et les meilleures pratiques.',
      tags: ['Java', 'POO', 'Design Patterns', 'Entreprise'],
      year: '2024',
      link: 'https://github.com/twillsonepitech/oop-java-project',
      github: 'https://github.com/twillsonepitech/oop-java-project',
      status: 'Terminé',
      language: 'Java'
    }
  ];

  return (
    <div className="space-y-10">
      <div>
        <h1 className="text-5xl font-bold mb-6 text-gray-900 dark:text-gray-100">
          Projets
        </h1>
        <p className="text-lg text-gray-600 dark:text-gray-400">
          Sélection de projets professionnels et d'expérimentations personnelles que j'ai réalisés.
        </p>
      </div>

      <div className="space-y-8">
        {projects.map((project, index) => (
          <article
            key={index}
            className="group border-l-2 border-transparent hover:border-gray-400 dark:hover:border-gray-600 pl-4 py-2 transition-all"
          >
            <div className="flex items-start justify-between mb-2">
              <div>
                <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 group-hover:text-gray-600 dark:group-hover:text-gray-400 transition-colors">
                  {project.name}
                </h2>
                <div className="flex items-center gap-3 mt-1 text-sm text-gray-500 dark:text-gray-400">
                  <span>{project.year}</span>
                  <span>•</span>
                  <span className="font-medium">{project.language}</span>
                  <span>•</span>
                  <span className="px-2 py-0.5 rounded text-xs bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-400">
                    {project.status}
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <a
                  href={project.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100 transition-colors"
                  aria-label="View on GitHub"
                >
                  <Github size={18} />
                </a>
              </div>
            </div>
            <p className="text-gray-600 dark:text-gray-400 mb-3 leading-relaxed">
              {project.description}
            </p>
            <div className="flex flex-wrap items-center gap-2">
              {project.tags.map((tag, tagIndex) => (
                <span
                  key={tagIndex}
                  className="px-2 py-1 text-xs rounded bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400"
                >
                  {tag}
                </span>
              ))}
            </div>
          </article>
        ))}
      </div>

      <Footer />
    </div>
  );
};

export default Projects;